<mat-accordion>

  @for (item of items$ | async; track index; let index = $index) {
    <mat-expansion-panel [expanded]="index===expandedItem()" #pan>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon [class]="item.iconColor">{{ item.icon }}</mat-icon>
          {{ item.title }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="hidden-body" [class.show-body]="pan.expanded">
        @for (item of item.content; track $index) {
          <div [innerHtml]="item"></div>
        }
        @if (item.href) {
          <a matIconButton class="accent" href="{{ item.href }}"
            target="{{ item.href.startsWith('http')? '_blank' : '_self'}}" rel="noopener">
            <mat-icon>open_in_new</mat-icon>
          </a>
        }
        <div class="spacer"></div>
      </div>
    </mat-expansion-panel>
  }

  <mat-expansion-panel #share>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>share</mat-icon>
        {{ 'app.share' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="hidden-body" [class.show-body]="share.expanded">
      @if (share.expanded) {
        <app-share></app-share>
      }
    </div>
  </mat-expansion-panel>
</mat-accordion>